import {useEffect, useMemo, useState} from 'react';
import {useErrorLoadingState} from '../../../helpers/hooks/useErrorLoadingState';
import CatalogService from '../../services/CatalogService';
import {ProductSwiperUI} from '../ProductSwiperUI';
import {useNavigate} from 'react-router-dom';

const useProductSwiperState = ({ filters, config }) => {
  const [products, setProducts] = useState([]);
  const [prices, setPrices] = useState();
  const pricesErrorLoading = useErrorLoadingState(true);
  const productsErrorLoading = useErrorLoadingState();

  useEffect(() => {
    const loadPrices = async (productCodes) => {
      setPrices(await CatalogService.getPrices(productCodes));
    };

    if (products) {
      const productCodes = products.map(({ pro_codigo }) => ({ pro_codigo }));
      pricesErrorLoading.run(loadPrices, [productCodes]);
    }
  }, [products]);

  useEffect(() => {
    const loadProducts = async (filters, config) => {
      const response = await CatalogService.getProducts(filters, config);
      setProducts(response.content);
    };

    if (filters) {
      productsErrorLoading.run(loadProducts, [filters, config]);
    }
  }, [filters, config]);

  return useMemo(() => ({
    prices,
    pricesLoading: pricesErrorLoading.loading,
    pricesError: pricesErrorLoading.error,
    products,
    productsLoading: productsErrorLoading.loading,
    productsError: productsErrorLoading.error
  }), [
    prices,
    pricesErrorLoading,
    products,
    productsErrorLoading
  ]);
};

export const ProductSwiper = ({
  filters,
  config,
  title,
  subtitle
}) => {
  const {
    prices,
    pricesError,
    pricesLoading,
    products,
    productsLoading,
    productsError
  }
    = useProductSwiperState({ filters, config });
  const navigate = useNavigate();

  return (
    <ProductSwiperUI
      data={{
        title: title,
        subTitle: subtitle,
        prices: { value: prices, loading: pricesLoading, error: pricesError },
        products: { value: products, loading: productsLoading, error: productsError }
      }}
      actions={{
        onClick: (details) => navigate(`/articulos/${encodeURI(details.pro_codigo)}`)
      }}
    />
  );
};